import { Action } from "history";

export const ROUTER_REDUCER_INITIAL_STATE = {
  location: {
    pathname: "",
    search: "",
    state: "",
    hash: "",
    key: "",
  },
  action: "POP" as Action,
};
